import "inputmask";

export const DeclarationOrder = () => {
	$(document).ready(() => {
		setupBrokers();
		setupDeductions();
		setupInputMasks();
		setupPhoneCopy();
		setupReportFileAccept();
	});
};

const copyToClipboard = (value) => {
	navigator.clipboard.writeText(value);
};

const renderFlashNotice = () => {
	const flashDiv = Object.assign(document.createElement("div"), {
		className: "flash flash_notice",
		innerText: "Телефон скопирован",
	});
	$(".flashes").html($(flashDiv));
};

const setupPhoneCopy = () => {
	const btn = $("#btn_copy_to_clipboard");
	btn.click(() => {
		const phone = btn.data("phone");
		if (phone) {
			copyToClipboard(phone.replace("+7", "8").replace(/\D+/g, ""));
			renderFlashNotice();
		}
	});
};

const applyReportFileAccept = ($select) => {
	const acceptByKind = $select.data("accept-by-kind");
	const accept = acceptByKind && acceptByKind[$select.val()];
	if (accept) {
		$select.closest("fieldset").find("input[type=file]").attr("accept", accept);
	}
};

const setupReportFileAccept = () => {
	$(document).on("change", "select[data-accept-by-kind]", (event) => {
		applyReportFileAccept($(event.currentTarget));
	});
	$(document).on("has_many_add:after", ".has_many_container", (_event, fieldset) => {
		applyReportFileAccept($(fieldset).find("select[data-accept-by-kind]"));
	});
};

const setupInputMasks = () => {
	Inputmask().mask($(":input"));
};

const applyCheckBoxes = ($parentCheckBox, childArray) => {
	if ($parentCheckBox.is(":checked")) {
		childArray.forEach((option) => {
			option.prop("disabled", false);
		});
	} else {
		childArray.forEach((option) => {
			option.prop("disabled", true);
		});
	}
};

const setupBrokers = () => {
	const $foreignBrokers = $("#declaration_order_foreign_brokers");
	const $interactiveBrokers = $("#declaration_order_interactive_brokers");
	const $saxoBank = $("#declaration_order_saxo_bank");
	const $just2trade = $("#declaration_order_just2trade");
	const $exante = $("#declaration_order_exante");
	const $etoro = $("#declaration_order_etoro");
	const $freedom_finance_armenia = $(
		"#declaration_order_freedom_finance_armenia",
	);
	const $freedom_finance_global = $(
		"#declaration_order_freedom_finance_global",
	);
	const $freedom_finance_europe = $(
		"#declaration_order_freedom_finance_europe",
	);
	const $cifra_markets = $(
		"#declaration_order_cifra_markets",
	);
	const $turlov_family_office_securities = $(
		"#declaration_order_turlov_family_office_securities",
	);
	const $bnp_paribas = $("#declaration_order_bnp_paribas");
	const $bcs_cyprus = $("#declaration_order_bcs_cyprus");
	const $open_broker = $("#declaration_order_open_broker");
	const $other_broker = $("#declaration_order_other_broker");
	const foreignBrokerOptions = [
		$interactiveBrokers,
		$saxoBank,
		$just2trade,
		$exante,
		$etoro,
		$freedom_finance_armenia,
		$freedom_finance_global,
		$freedom_finance_europe,
		$cifra_markets,
		$turlov_family_office_securities,
		$bnp_paribas,
		$bcs_cyprus,
		$open_broker,
		$other_broker,
	];

	applyCheckBoxes($foreignBrokers, foreignBrokerOptions);

	$foreignBrokers.click(() => {
		applyCheckBoxes($foreignBrokers, foreignBrokerOptions);
	});
};

const setupDeductions = () => {
	const $deductions = $("#declaration_order_deductions");
	const $investment = $("#declaration_order_investment");
	const $lossTransfer = $("#declaration_order_loss_transfer");
	const $property = $("#declaration_order_property");
	const $social = $("#declaration_order_social");
	const $standard = $("#declaration_order_standard");
	const deductionsOptions = [
		$investment,
		$lossTransfer,
		$property,
		$social,
		$standard,
	];

	applyCheckBoxes($deductions, deductionsOptions);

	$deductions.click(() => {
		applyCheckBoxes($deductions, deductionsOptions);
	});
};
